import {UploadedFilesGrid} from './components/UploadedFilesGrid';

export default UploadedFilesGrid;
